import React from "react";
import cellphoneIcon from "@iconify/icons-mdi/cellphone-iphone";
import deskphoneIcon from "@iconify/icons-mdi/deskphone";
import { MyHrContractCardItem } from "my-hr/components";

type PhoneCardItemProps = {
  item: {
    type: "work" | "workMobile";
    number: string;
  };
};

export const MyHrPhoneCardItem: React.FC<PhoneCardItemProps> = ({ item }) => {
  if (item.type === "work") {
    return <MyHrContractCardItem icon={deskphoneIcon} label={item?.number} />;
  } else if (item.type === "workMobile") {
    return <MyHrContractCardItem icon={cellphoneIcon} label={item?.number} />;
  }
  return null;
};

export default MyHrPhoneCardItem;
